import { Field, Float, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'

@ObjectType()
@InputType('GpsLocationInput')
export class GpsLocation {
  @Field(() => String)
  @Prop({ type: String })
  type: string

  @Field(() => [Float])
  @Prop({ type: [Number] })
  coordinates: number[]
}
